import { gql, useQuery } from "@apollo/client"
import { useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

const CarIssueRedirectQuery = gql`
    query CarIssueRedirectQuery($id: ID!) {
        carIssue(id: $id) {
            id
            car {
                id
                pk
            }
        }
    }
`

const CarIssueRedirect = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const { data, loading, error } = useQuery(CarIssueRedirectQuery, {
        variables: { id },
        skip: !id,
    })

    useEffect(() => {
        const carPk = data?.carIssue?.car?.pk
        if (carPk) {
            navigate(`/car/${carPk}#issues`, { replace: true })
        }
    }, [data?.carIssue?.car?.pk, navigate])

    if (loading) {
        return <div className="p-3">Opening car details...</div>
    }

    if (error || !data?.carIssue?.car?.pk) {
        return (
            <div className="p-3">
                Unable to find a car for this issue.{" "}
                <Link to="/maintenance/issues/">Go to Issues List</Link>
            </div>
        )
    }

    return <div className="p-3">Redirecting...</div>
}

export default CarIssueRedirect
